<template>
	<label class="form-group buttons m-0">
		<input
			type="file"
			accept="image/*"
			class="input-file"
			:multiple="multiple"
			@change="onChange">
		<div
			class="btn cur-p"
			:class="[`btn-${btnStyle}`, { 'is-loading': counter > 0 }]">
			{{ label }}
		</div>
	</label>
</template>

<script>
import mediaApi from '@/api/media';

export default {
	name: 'ImageUploader',
	props: {
		multiple: {
			type: Boolean,
			default: false,
		},
		btnStyle: {
			type: String,
			default: 'primary',
		},
		resize: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: 'Upload Image',
		},
		public: {
			type: Boolean,
			default: true,
		},
		directory: {
			type: String,
			default: '',
		},
		prefix: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			counter: 0,
			progress: [],
		};
	},
	methods: {
		onChange(event) {
			// console.log('event: ', event);
			const files = event.target.files;
			for (let index = 0; index < files.length; index++) {
				const image = files[index];

				// Preview
				const reader = new FileReader();
				reader.onload = (e) => {
					const imageData = e.target.result;
					this.$emit('loaded', imageData);
				};
				reader.readAsDataURL(image);

				this.upload(image, index);
			}
		},
		upload(image, index) {
			this.counter++;

			const resize = this.resize ? 1 : 0;
			const uploadParams = new FormData();
			uploadParams.append('image', image);
			uploadParams.append('resize', resize);

			if (!this.public) {
				uploadParams.append('is_public', false);
			}

			if (this.directory && this.directory !== '') {
				uploadParams.append('directory', this.directory);
			}

			if (this.prefix && this.prefix !== '') {
				uploadParams.append('prefix', this.prefix);
			}

			const callback = (response) => {
				this.counter--;
				const path = response.data;
				const imageUrl = this.public ? `${this.mediaUrlPrefix}/${path}` : `/${path}`;
				this.$emit('uploaded', imageUrl, image);
			};

			const errorCallback = () => {
				this.counter--;
			};

			const progressCallback = (percentage) => {
				this.progress[index] = percentage;
			};

			// Upload Image
			mediaApi.uploadImage(uploadParams, callback, errorCallback, progressCallback);
		},
	},
};
</script>
